{
  "common": {
    "cancel": "Отмена",
    "close": "Закрыть",
    "delete": "Удалить",
    "edit": "Редактировать",
    "save": "Сохранить",
    "show": "Показать",
    "hide": "Скрыть",
    "search": "Поиск…",
    "clearSearch": "Закрыть поиск",
    "noMatch": "Ничего не найдено",
    "retry": "Повторить"
  },
  "page": {
    "preview": "Просмотр",
    "save": "Сохранить",
    "saveHint": "Сохранить (Ctrl+S)",
    "loading": "Загрузка…",
    "loadError": "Не удалось загрузить главную панель"
  },
  "save": {
    "success": "Сохранено",
    "successHint": "Изменения видны всем пользователям",
    "error": "Не удалось сохранить",
    "unknownSection": "Раздел, связанный с меткой, не найден",
    "conflictTitle": "Страница изменена другим пользователем",
    "conflictTextBy": "{{name}} сохранил(а) новую версию в {{time}}. Можно загрузить последнюю версию или перезаписать её своими изменениями.",
    "conflictText": "Новая версия страницы сохранена в {{time}}. Можно загрузить последнюю версию или перезаписать её своими изменениями.",
    "reload": "Загрузить заново",
    "overwrite": "Перезаписать",
    "reloaded": "Загружена последняя версия",
    "linksDropped": "Удалены ссылки на удалённый раздел: {{names}}",
    "unknownSectionHint": "Выберите раздел заново в настройках меток: {{names}}"
  },
  "unsaved": {
    "title": "Есть несохранённые изменения. Выйти?",
    "text": "Если выйти без сохранения, внесённые изменения будут потеряны.",
    "save": "Сохранить",
    "discard": "Выйти без сохранения",
    "stay": "Остаться на странице"
  },
  "preview": {
    "back": "Вернуться к редактированию",
    "label": "{{title}} — режим просмотра"
  },
  "types": {
    "background": "Фон",
    "clock": "Часы",
    "date": "Дата",
    "indicator": "Показатель",
    "title": "Заголовок",
    "marker": "Метка",
    "image": "Изображение",
    "gif": "GIF",
    "video": "Видео",
    "sectionGrid": "Разделы"
  },
  "popoverTitles": {
    "background": "Фон",
    "clock": "Часы",
    "date": "Дата",
    "indicator": "Показатель",
    "title": "Заголовок",
    "marker": "Метка",
    "image": "Изображение",
    "gif": "GIF",
    "video": "Видео"
  },
  "rail": {
    "label": "Виджеты",
    "hint": "{{name}} — нажмите, чтобы настроить, или перетащите на холст",
    "backgroundHint": "Фон — фон главной панели"
  },
  "canvas": {
    "label": "Холст главной панели",
    "roledescription": "область редактирования",
    "emptyTitle": "Виджеты ещё не добавлены",
    "emptyText": "Выберите виджет на панели «Виджеты» справа и добавьте его на холст",
    "zoomIn": "Увеличить",
    "zoomOut": "Уменьшить",
    "fit": "По размеру экрана",
    "zoom100": "Показать 100%",
    "zoomLevel": "Масштаб {{value}}%",
    "locked": "Заблокировано"
  },
  "menu": {
    "duplicate": "Дублировать",
    "forward": "Вперёд",
    "backward": "Назад",
    "paste": "Вставить"
  },
  "elements": {
    "title": "Элементы",
    "search": "Поиск элементов",
    "add": "Добавить элемент",
    "empty": "Элементов нет",
    "emptyHint": "Элементы ещё не добавлены.",
    "lock": "Заблокировать",
    "unlock": "Разблокировать",
    "rename": "Переименовать",
    "reorderHint": "Перетащите или нажмите Alt + ↑ / ↓, чтобы изменить порядок. Двойной щелчок — переименовать.",
    "deleted": "«{{name}}» удалён",
    "undo": "Отменить"
  },
  "sections": {
    "title": "Разделы",
    "search": "Поиск разделов",
    "add": "Добавить раздел",
    "count": "{{count}} шт. показателей",
    "empty": "Разделов нет",
    "emptyHint": "Разделов ещё нет. Нажмите «Добавить раздел», чтобы создать новый раздел.",
    "loadError": "Не удалось загрузить разделы",
    "saveError": "Не удалось сохранить изменение",
    "deleteTitle": "Удалить раздел",
    "deleteText": "Раздел «{{name}}», его папки, чертежи и показатели будут удалены.",
    "deleted": "Раздел удалён",
    "deleteError": "Не удалось удалить раздел",
    "reorderHint": "Перетащите или нажмите Alt + ↑ / ↓, чтобы изменить порядок карточек. Нажмите на название, чтобы открыть настройки раздела."
  },
  "sectionModal": {
    "createTitle": "Новый раздел",
    "createSubtitle": "Добавить страницу мониторинга",
    "editTitle": "Редактировать раздел",
    "editSubtitle": "Настройки страницы мониторинга",
    "name": "Название раздела",
    "namePlaceholder": "Например: Клинометр",
    "nameRequired": "Введите название раздела",
    "nameTaken": "Раздел с таким названием уже существует",
    "icon": "Иконка",
    "uploadIcon": "Загрузить иконку",
    "uploadIconHint": "SVG или PNG, до 256 КБ, не меньше 48×48 px",
    "iconType": "Иконка может быть только SVG или PNG",
    "iconTooBig": "Размер иконки не должен превышать 256 КБ",
    "iconTooSmall": "Иконка должна быть не меньше 48×48 px",
    "cardMode": "Что показывать на карточке",
    "modeFull": "Иконка, название, число",
    "modeName": "Только название",
    "countSource": "Источник числа",
    "countAuto": "Автоматически",
    "countManual": "Вручную",
    "manualCount": "Введите число вручную",
    "manualCountHint": "шт. (значение, заданное вручную)",
    "countInvalid": "Введите целое число от 0 до 999 999",
    "create": "Добавить раздел",
    "created": "Раздел добавлен",
    "updated": "Раздел сохранён",
    "limit": "Достигнут предел количества разделов (50)",
    "saveError": "Не удалось сохранить раздел"
  },
  "popover": {
    "close": "Закрыть",
    "drag": "Переместить панель",
    "add": "Добавить",
    "deleteWidget": "Удалить виджет",
    "scale": "Размер",
    "decrease": "уменьшить",
    "increase": "увеличить"
  },
  "empty": {
    "clock": {
      "title": "Добавить: часы",
      "text": "Добавьте виджет «Часы»"
    },
    "date": {
      "title": "Добавить: дата",
      "text": "Добавьте виджет «Дата»"
    },
    "indicator": {
      "title": "Добавить: показатель",
      "text": "Добавьте виджет «Показатель»"
    },
    "title": {
      "title": "Добавить: заголовок",
      "text": "Добавьте виджет «Заголовок»"
    },
    "marker": {
      "title": "Добавить: метка",
      "text": "Добавьте виджет «Метка»"
    },
    "image": {
      "title": "Добавить: изображение",
      "text": "Добавьте виджет «Изображение»"
    },
    "gif": {
      "title": "Добавить: GIF",
      "text": "Добавьте виджет «GIF»"
    },
    "video": {
      "title": "Добавить: видео",
      "text": "Добавьте виджет «Видео»"
    }
  },
  "clock": {
    "seconds": "Показывать секунды"
  },
  "date": {
    "format": "Формат"
  },
  "indicator": {
    "icon": "Иконка",
    "source": "Источник значения",
    "manual": "Вручную",
    "pick": "Выбрать",
    "name": "Название",
    "value": "Значение",
    "unit": "Единица",
    "sensor": "Устройство",
    "sensorPlaceholder": "Выберите устройство",
    "sensorSearch": "Поиск устройства или показателя",
    "sensorsLoading": "Загрузка устройств…",
    "noSensors": "Устройства не найдены"
  },
  "title": {
    "title": "Заголовок",
    "titlePlaceholder": "Введите заголовок",
    "titleSize": "Размер заголовка",
    "subtitle": "Подзаголовок",
    "subtitlePlaceholder": "Введите название объекта",
    "subtitleSize": "Размер подзаголовка",
    "accentBar": "Показывать полосу слева",
    "logo": "Показывать логотип",
    "logoHint": "Перед заголовком в режиме просмотра"
  },
  "marker": {
    "name": "Название",
    "link": "Связать с разделом",
    "noLink": "Нет",
    "side": "Сторона подписи",
    "sideAuto": "Авто",
    "sideLeft": "Слева",
    "sideRight": "Справа"
  },
  "media": {
    "upload": {
      "image": "Загрузить изображение",
      "gif": "Загрузить GIF",
      "video": "Загрузить видео"
    },
    "aspect": "Соотношение сторон",
    "width": "Ширина",
    "zoom": "Увеличение",
    "autoplay": "Автовоспроизведение (без звука)",
    "loop": "Повтор",
    "replace": "Заменить",
    "remove": "Убрать файл",
    "uploading": "Загрузка…",
    "uploadError": "Не удалось загрузить файл",
    "tooLarge": "Размер файла не должен превышать {{max}}",
    "badType": "Файлы этого типа не принимаются",
    "noRight": "У вас нет права загружать файлы",
    "meta": "{{w}} × {{h}} px · {{size}}"
  },
  "background": {
    "emptyTitle": "Добавить фон",
    "emptyText": "Добавьте виджет фона",
    "upload": "Загрузить файл",
    "opacity": "Непрозрачность",
    "scale": "Увеличение",
    "remove": "Удалить фон",
    "removeTitle": "Удалить фон",
    "removeText": "Файл фона будет убран с главной панели. До сохранения можно вернуть через Ctrl+Z.",
    "type": "Тип фона",
    "typeImage": "Изображение",
    "typeVideo": "Видео",
    "typeGif": "GIF"
  }
}
